import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Button, Input, Anchor, message, Popover, Collapse, Carousel, Dropdown, Statistic, Modal } from "antd";
import { DotLoader } from 'react-spinners';
import CountUp from 'react-countup';
import {
  RightOutlined,
  PlusOutlined
} from "@ant-design/icons";
import "animate.css";
import WOW from "wow.js";
import suo from "@/assets/images/suo.png";

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useAppKitAccount, useAppKit, useAppKitNetwork, useWalletInfo } from "@reown/appkit/react";
import { base } from '@reown/appkit/networks'
import { tokenAbi, LOCKLPABI, LOCKDEAIABI } from "@/web3/ido.js";
import { useAccount, useSignMessage, useDisconnect, useReadContract, useBalance, useWriteContract, useWaitForTransactionReceipt, useSwitchChain, useBlockNumber, useSendTransaction, useGasPrice } from 'wagmi'
import { parseEther, parseUnits, parseGwei, formatEther } from 'viem';
import { useQueryClient } from '@tanstack/react-query'
import dayjs from "dayjs";
import axios from 'axios';
const { Link } = Anchor;
const Index = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [redeemId, setRedeemId] = useState(0);
  const { address, isConnected, caipAddress, status } = useAppKitAccount()


  useEffect(() => {
    const timeout = setTimeout(() => {
      if (address) {
        getList()
      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [address]);
  const getList = async () => {

    const res = await axios.get('https://www.1322.cloud/api/performance?uid=' + address);
    console.log("res", res.data)
     if (res.data.code === 200 && res.data.data) {
        setDataList(res.data.data)
      }
  }
  const saveNumberTwo = (num) => {
    if (num * 1 === 0) return 0;
    let arr = (num + "").split(".");
    if (arr.length === 2) {
      let new_num = arr[0] + "." + arr[1].substring(0, 2);
      return new_num === "0.00" ? "0" : new_num;
    } else {
      return num + ".00";
    }
  }
   const against = (t) => {
    if (!t) return "";
    return t.substring(0, 3) + "****" + t.substring(t.length - 4, t.length);
  };
  return (
    <div className="history_1_box">
      <div className="table">
        <div className="thead">
          <div className="td">{t("Address")}</div>
          <div className="td">{t("Lock in Deai Performance")}</div>
          <div className="td">{t("Lock up LP performance")}</div>
          <div className="td">{t("Lock in new Deai performance")}</div>
        </div>
        {
          dataList.map((item, index) => {
            return (<div className="tbody" key={index}>
              <div className="td">{against(item.uid)}</div>
              <div className="td">{item.deai}</div>
              <div className="td">{item.LP}</div>
              <div className="td">{item.new_deai}</div>
            </div>)
          })
        }
      </div>

    </div >
  );
};
export default Index;
